import React, { useState } from 'react'
import styled from 'styled-components'
import MainLayoutWrapper from '../../../components/wrappers/mainLayoutWrapper'
import Logo from '../../../assets/logoN2.png';
import './registerScreen.css';
import { LoginMethod } from '../../../enum/loginMethod.enum';
import { Link } from 'react-router-dom';
import EmailRegister from './EmailRegister';

const RegisterModal = styled.div`
    display: flex;
    flex-direction: column;
    width: 70vw;
    border-radius: 15px;
    align-items: center;
`;

const RegisterActions = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 8px;
    width: 55vw;
`;

const RegisterScreen = () => {
    const [loginMethod, setLoginMethod] = useState(LoginMethod.Email);

    const handleEmailSignUp = (values) => {

    }

    return (
        <MainLayoutWrapper>
            <RegisterModal>
                <img src={Logo} className={'logo-image'}/>
                <EmailRegister onSubmit={handleEmailSignUp}/>
            </RegisterModal>
            <RegisterActions>
                <Link to={'/'}>Already registered ? Sign in!</Link>
            </RegisterActions>
        </MainLayoutWrapper>
    )
}

export default RegisterScreen;